import * as React from 'react'
import cx from 'classnames'
import styles from './button.module.css'

export interface Props {
  /** Label of the button */
  children: string
  /** Class of the button  */
  className: string
}

/** Button */
const Button: React.FC<Props> = ({ className, children }) => (
  <button className={cx(styles.button, className)}>{children}</button>
)

export { Button }
